import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, UntypedFormControl } from '@angular/forms';
import { asyncScheduler, Subject } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
import { AppService } from '@shared/services/app.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { LastResultType } from '@shared/classes/pagination-base.class';

@UntilDestroy()
@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
})
export class SearchInputComponent implements OnInit, OnDestroy {
  @Input() control: FormControl<string>;
  @Input() placeholder: string = $localize`Поиск`;
  @Input() lastResultIsEmpty$: Subject<LastResultType>;
  @Output() searchTermChanded = new EventEmitter<string>();
  searchControl = new UntypedFormControl('');

  constructor(private appService: AppService) {}

  ngOnInit(): void {
    this.searchControl.valueChanges
      .pipe(
        untilDestroyed(this),
        throttleTime(400, asyncScheduler, { leading: true, trailing: true }),
      )
      .subscribe({
        next: (data) => {
          if (this.control) {
            this.control.setValue(data);
          }
          this.searchTermChanded.emit(data);
          this.appService.pageSearchContent$.next(data);
        },
      });

    if (this.control?.value) {
      this.searchControl.setValue(this.control.value);
    }
  }

  ngOnDestroy() {
    this.appService.pageSearchContent$.next(null);
  }
}
